.scroller-list-flex,
.scroller-list-grid {
  padding: 0;
  list-style: none;
  width: fit-content;
  --grid-gap: 20px;
  --margin: calc(var(--rds-gutter));
  --swimlane-item-width: clamp(200px, 16vw, 300px);
}

.scroller-list-grid {
  display: grid;
  grid-auto-flow: column;
  gap: var(--grid-gap);
}

.scroller-item {
  flex-shrink: 0;

  &:first-child {
    /* adds the margin to the first and last child of each swimlane */
    margin-left: var(--margin);
  }

  &:last-child {
    margin-right: var(--margin);
  }
}

.scroller-list-grid-featured {
  --swimlane-item-width: clamp(270px, 20vw, 400px);
}

.scroller-list-grid-standard-portrait {
  --swimlane-item-width: clamp(125px, 14vw, 200px);
}

.scroller-list-grid-hero-portrait {
  --swimlane-item-width: clamp(175px, 16vw, 275px);
}

.scroller-list-flex {
  display: flex;
  gap: var(--grid-gap);
}

.scroller-list-grid-numbered,
.scroller-list-grid-numbered-portrait,
.scroller-list-grid-live {
  --grid-gap: 0px;
}

.scroller-list-grid-live {
  --swimlane-item-width: clamp(150px, 15vw, 200px);
}

.scroller-list-grid-menu-circle {
  --swimlane-item-width: clamp(110px, 8vw, 165px);
}

.scroller-list-grid-menu-logo {
  --swimlane-item-width: clamp(120px, 10vw, 175px);
}

.scroller-list-grid-menu-text {
  --swimlane-item-width: fit-content;
}

.scroller-title-wrapper {
  display: flex;
  align-items: center;
  /* space for focus outline */
  padding-top: 4px;
}

.scroller-title-wrapper h2 {
  margin-right: 0;
}

.scroller-title-link {
  display: flex;
  align-items: center;
  margin-left: 1.5rem;
  line-height: 1.5rem;
}

/* a visually hidden heading is out of flow, so the link that follows it carries the gutter itself */
.scroller-title-wrapper :global(.sr-only) + a {
  margin-left: var(--rds-gutter);
}

.core-scroll-container {
  /* Removes scrollbars in firefox */
  overflow: hidden;
  display: flex;
  align-items: center;

  &:hover {
    & .scroll-navigation-arrow {
      /* display scrollArrows for desktop but never for touch devices */
      @media (pointer: fine) {
        display: block !important;
      }
    }
  }

  & .core-scroll-element {
    flex-grow: 1;

    /* hide scrollbars */
    /*  - in Firefox */
    overflow: -moz-scrollbars-none;
    scrollbar-width: none;

    /* - in Safari, Chrome, Edge */
    &::-webkit-scrollbar {
      width: 0 !important;
      display: none;
    }
  }
}

.chevron-icon {
  transform: rotate(180deg);
}
